<template lang="html">
  <div id="payment" class="row">
    <div v-if="loader" class="loader"></div>
    <div class="col-lg-3"></div>
    <div class="col-lg-9 payment-container">
      <div class="row">
        dfsssssss
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      translation: null,
      loader: false
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    window.pageHeader = this.translation.header.home;
    this.getUserPayment();
  },
  methods:{
    getUserPayment: function(){
      this.loader = true;
      var self = this;
      axios.get('get-payment-status')
      .then(function (response){
        console.log(response);
        self.loader = false;
      })
    }
  }
}
</script>

<style lang="css" scoped>
#app #payment{
  background: #f6f6f6;
  height: 100vh;
}
#app .payment-container{
  margin-top: 7em;
}
</style>
